import { render, staticRenderFns } from "./cotacao.vue?vue&type=template&id=0798e892"
import script from "./cotacao.ts?vue&type=script&lang=js&external"
export * from "./cotacao.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0798e892')) {
      api.createRecord('0798e892', component.options)
    } else {
      api.reload('0798e892', component.options)
    }
    module.hot.accept("./cotacao.vue?vue&type=template&id=0798e892", function () {
      api.rerender('0798e892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/compras/cotacao.vue"
export default component.exports